export const useEnvironment = () => {
    const isProduction = process.env.NODE_ENV !== 'development';
    const isDevelopment = (process.env.NODE_ENV || 'development') === 'development';

    return {
        isProduction,
        isDevelopment
    };
}